import Vue from 'vue';
import Vuei18n from 'vue-i18n';
import English from './lang/English.json';
import Polish from './lang/Polish.json';
import Swedish from './lang/Swedish.json';
import French from './lang/French.json';
import Finnish from './lang/Finnish.json';
import German from './lang/German.json';
import Italian from './lang/Italian.json';
import Spanish from './lang/Spanish.json';
import Norwegian from './lang/Norwegian.json';
import Danish from './lang/Danish.json';
import Russian from './lang/Russian.json';
import Portuguese from './lang/Portuguese.json';
import Dutch from './lang/Dutch.json';

import store from '../store/store';

Vue.use(Vuei18n);

function getUserLanguage() {
  setTimeout(() => {
    if (store.state.user.user) {
      i18n.locale = store.state.user.user.language;
      return store.state.user.user.language;
    }
    if (localStorage.getItem('exideUserLanguage')) {
      return localStorage.getItem('exideUserLanguage');
    }
    return 'English';
  });
}

export const i18n = new Vuei18n({
  locale: getUserLanguage(),
  fallbackLocale: 'English',
  messages: {
    English,
    Polish,
    Swedish,
    French,
    Finnish,
    German,
    Italian,
    Spanish,
    Norwegian,
    Danish,
    Russian,
    Portuguese,
    Dutch
  },
  silentTranslationWarn: true
});
